import {NgModule} from "@angular/core";
import {MaterialModule} from "@modules/material.module";

import {AppCoreModule} from "@modules/app.core.module";
import {AppSharedModule} from "@modules/app-shared.module";

import {HomeScreenComponent} from '@core-components/home-screen/home-screen.component';
import {MyPropertiesLandingComponent} from '@core-components/home-screen/my-properties-landing/my-properties-landing.component';
import {LandlordPropertiesCarouselComponent} from '@shared-components/landlord-properties-carousel/landlord-properties-carousel.component';

import {CustomerSupportComponent} from "@features/support/customer-support/customer-support.component";
import {PosHelpCenterComponent} from "@features/support/pos-help-center/pos-help-center.component";
import {RequestPosDialogComponent} from "@features/support/request-pos-dialog/request-pos-dialog.component";

import {CheckYourEmailComponent} from '@features/password-reset/check-your-email/check-your-email.component';
import {ForgotPasswordComponent} from '@features/password-reset/forgot-password/forgot-password.component';
import {ResetPasswordComponent} from '@features/password-reset/password-reset/password-reset.component';
import {VerifyUpdatePasswordOtpComponent} from '@features/password-reset/verify-update-password-otp/verify-update-password-otp.component';
import {LoginComponent} from '@features/login/login.component';
import {VerifyAccountComponent} from '@features/verify-account/verify-account.component';


const components = [
  HomeScreenComponent,
  LandlordPropertiesCarouselComponent,
  MyPropertiesLandingComponent,
  CustomerSupportComponent,
  PosHelpCenterComponent,
  RequestPosDialogComponent,
  CheckYourEmailComponent,
  ForgotPasswordComponent,
  ResetPasswordComponent,
  VerifyUpdatePasswordOtpComponent,
  VerifyAccountComponent,
  LoginComponent,
];

@NgModule({
  imports: [
    MaterialModule,
    AppCoreModule,
    AppSharedModule
  ],
  declarations: [...components],
  exports: [...components],
})
export class FeaturePortalModule {
}
